import { render } from "./RegionImagesDetail.vue?vue&type=template&id=c793f040"
import script from "./RegionImagesDetail.vue?vue&type=script&lang=js"
export * from "./RegionImagesDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__